// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610052235/js/" + chunkId + "." + {"44":"e378b46c","225":"13d5b72e","481":"aa7885a4","486":"6262cf2c","770":"2b08a3f5"}[chunkId] + ".0.7426875481035827.chunk.js";
};